import Service from "../Service";

const resource = "washselection/";

export default {
    save(obj, requestID) {
        console.log('service ', obj);
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },

    pagination(obj, requestID) {
        return Service.post(resource + "pagination", obj, {
            params: { requestID: requestID },
        });
    },

    lotcalibratedtoday(obj, requestID) {
        return Service.post(resource + "lotcalibratedtoday", obj, {
            params: { requestID: requestID },
        });
    },

    reportpdf(dtr, requestID) {
        return Service.post(resource + "reportpdf", dtr, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
            params: { requestID: requestID },
        });
    },

};